/**
 * Dueños de cada nivel de un contacto, con la **misma regla que la ficha del presupuesto**.
 *
 * La convención canónica del admin y de la API: dentro de cada nivel, el dueño es la participación
 * de `position` más baja. El presupuesto la aplica así (`quoteDetail.tsx`):
 *
 *     storeParticipations.slice(0, 1)                        // una sola del store
 *     sellerParticipations.filter(p => p.identifier === s).slice(0, 1)   // una por seller
 *
 * La bandeja de Conversaciones no filtraba nada y mostraba **todas** las participaciones del
 * contacto, de ahí que aparecieran de más.
 *
 * A diferencia del presupuesto, una conversación no conoce la lista de sellers involucrados —sólo el
 * store del canal—, así que los sellers se deducen de las participaciones: una línea por cada seller
 * que aparezca, con su dueño.
 */
import { ContactParticipation } from "@/services/contacts.api";

const porPosicion = (a: ContactParticipation, b: ContactParticipation) =>
  (Number(a.position) || 0) - (Number(b.position) || 0);

export function ownerParticipations(
  participations: ContactParticipation[] = [],
): ContactParticipation[] {
  const store = participations.filter((p) => p.type === "store").sort(porPosicion).slice(0, 1);

  // Un dueño por seller: se agrupa por `identifier` y de cada grupo queda el de menor `position`.
  const porSeller = new Map<string, ContactParticipation>();
  for (const p of participations.filter((x) => x.type === "seller").sort(porPosicion)) {
    const clave = p.identifier || "";
    if (!porSeller.has(clave)) porSeller.set(clave, p);
  }

  // El store primero, igual que en la ficha del presupuesto.
  return [...store, ...porSeller.values()];
}
